import React from 'react'
import {Link, Router} from '@reach/router'
import { Card, Button } from 'antd'
import RecipeCreate from "./create/RecipeCreate";
import Recipe from "./read/Recipe";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import RecipeUpdateContainer from "./update/RecipeUpdateContainer";
import RecipeDetailedList from "./details/RecipeDetailedList";
import './recipe.css'

const RecipeLayoutContainer = () => {


    return (
        <Card
            title={'Reçete Listesi'}
            extra={window.location.pathname === '/landing/recipe' ?
                <Button
                    type={'primary'}
                >
                    <Link to={'create'}>
                        Yeni Ekle
                    </Link>
                </Button>
                    :null
            }
        >

            <Router>
                <Recipe path={'/'}/>
                <RecipeCreate path={'/create'}/>
                <RecipeUpdateContainer path={'/update/:recipeId'}/>
                <RecipeDetailedList path={'/details/:recipeId'} />
            </Router>
        </Card>
    );

}
export default RecipeLayoutContainer